import React, { useEffect, useState } from "react";

const Step2SelectContent = ({ selectedPatient, selectedContent, setSelectedContent, goToStep }) => {
    const [search, setSearch] = useState("");
    const [contents, setContents] = useState([]);

    useEffect(() => {
        const fetchContents = async () => {
            try {
                const res = await fetch("https://apipro.intern.saludti.es/digimevo/mock");
                const data = await res.json();

                // ⚠️ Comprueba si `data` es un array directamente, o si viene dentro de un campo `data`
                const contentList = Array.isArray(data) ? data : data.data;

                if (Array.isArray(contentList)) {
                    setContents(contentList);
                } else {
                    console.error("La respuesta no es un array:", data);
                    setContents([]); // fallback
                }
            } catch (error) {
                console.error("Error al cargar contenidos educativos:", error);
                setContents([]); // fallback
            }
        };

        fetchContents();
    }, []);

    const filteredContents = contents.filter((content) =>
        content.title.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="step active">
            <div className="section">
                <h2 className="section-title">
                    <span className="number">2</span> Seleccionar contenido
                </h2>

                <div className="patient-item selected">
                    <div className="patient-name">{selectedPatient?.fullName}</div>
                    <div className="patient-details">{selectedPatient?.email}</div>
                </div>

                <div className="search-container">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Buscar contenido..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* TODO: Agregar lógica para filtrar por tipo si lo deseas */}
                <div className="filter-tabs">
                    <div className="filter-tab active">Todos</div>
                    <div className="filter-tab">Vídeos</div>
                    <div className="filter-tab">Interactivos</div>
                    <div className="filter-tab">Neurología</div>
                </div>

                {filteredContents.map((content) => (
                    <div
                        key={content.id}
                        className={`content-item ${selectedContent?.id === content.id ? "selected" : ""}`}
                        onClick={() => setSelectedContent(content)}
                    >
                        <div className="content-thumbnail">
                            <span>{content.icon || "🎬"}</span>
                        </div>
                        <div className="content-details">
                            <div className="content-title">{content.title}</div>
                            <div className="content-meta">
                                <span className="content-tag">{content.tag}</span>
                                <span>{content.duration}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="sticky-footer">
                <div className="progress-indicator">
                    <div className="progress-dot active"></div>
                    <div className="progress-dot active"></div>
                    <div className="progress-dot"></div>
                </div>
                <button
                    className="action-button"
                    disabled={!selectedContent}
                    onClick={() => goToStep(3)}
                >
                    Continuar
                </button>
            </div>
        </div>
    );
};

export default Step2SelectContent;
